import type { NavigationItemType } from "../../../root/layout/SidebarMenuItem";
import type { Paths } from "../../../shared/usePrivacyNavigate";
import {
  personalDataControllersGridPageRoutes,
  prefetchPersonalDataControllersGridViewAndForm,
} from "./PersonalDataControllersGridPage";

export const route: NavigationItemType["route"] = {
  path: "settings/personal-data-controllers",
  children: personalDataControllersGridPageRoutes,
};
export const to = (paths: Paths) => paths.pdcGrid();
export const prefetch = prefetchPersonalDataControllersGridViewAndForm;
